export const parseUrlParams = (urlParams) => {
    let dString;
    if (urlParams) {
        try {
            dString = atob(urlParams).split("/");
        } catch (error) {
            dString = [];
        }
    } else {
        dString = [];
    }

    const urlParamsValues = {};

    if (dString.length > 0) {
        dString.forEach((param, index) => {
            if (/^(254\d{9}|07\d{8}|\+254\d{10})$/.test(param)) {
                urlParamsValues[`urlPhone`] = param;
            } else if (/^\d+$/.test(param) && parseInt(param) <= 500000) {
                urlParamsValues[`urlAmount`] = param;
            } else {
                urlParamsValues[`urlOption`] = param;
            }
        });
    }

    return urlParamsValues;
};
